import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { useTable, useSortBy, useGlobalFilter, useExpanded } from "react-table";

import "bootstrap/dist/css/bootstrap.min.css";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import moment from "moment";
import Swal from "sweetalert2";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Link } from "react-router-dom";
import { booleanOptions } from "./masterList";

const ItemReturnManagement = () => {

  const [voucherType, setVoucherType] = useState(null);
  const [voucherData, setVoucherData] = useState([]);
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [selectedLedger, setSelectedLedger] = useState(null);
  const [editableItems, setEditableItems] = useState({});
  const [savingItemId, setSavingItemId] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [originalReturnable, setOriginalReturnable] = useState({});
  const email = localStorage.getItem("email");
  const loginId = localStorage.getItem("sewadarId");
  
  const token = localStorage.getItem("token");
  const getItemKey = (voucherId, itemId) => `${voucherId}_${itemId}`;

  const handleEditItem = (voucherId, itemId, currentValue) => {
    setOriginalReturnable((prev) => ({
      ...prev,
      [getItemKey(voucherId, itemId)]: currentValue,
    }));
  
    setEditableItems((prev) => ({
      ...prev,
      [getItemKey(voucherId, itemId)]: true,
    }));
  };
  
  const handleCancelItem = (voucherId, itemId) => {
    const key = getItemKey(voucherId, itemId);
    const originalValue = originalReturnable[key];
  
    // revert value
    setVoucherData((prev) =>
      prev.map((v) =>
        v.id === voucherId
          ? {
              ...v,
              items: v.items.map((it) =>
                it.id === itemId
                  ? { ...it, returnable: originalValue }
                  : it
              ),
            }
          : v
      )
    );
  
    // exit edit mode
    setEditableItems((prev) => ({
      ...prev,
      [key]: false,
    }));
  };
  

const handleReturnableChange = (voucherId, itemId, value) => {
  setVoucherData((prev) =>
    prev.map((v) =>
      v.id === voucherId
        ? {
            ...v,
            items: v.items.map((it) =>
              it.id === itemId
                ? { ...it, returnable: value === "Yes" }
                : it
            ),
          }
        : v
    )
  );
};


const handleSaveItem = async (voucherId, itemId, returnable) => {
  try {
    setSavingItemId(itemId);

    await apiClient.post(SERVER_BASE + "/updateDeliveryChallanItemReturnable",
      {
        voucherId,
        itemId,
        returnable,
        createdBy:email 
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    Swal.fire("Saved", "Returnable updated successfully", "success");

    setEditableItems((prev) => ({
      ...prev,
      [getItemKey(voucherId, itemId)]: false,
    }));
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Failed to update returnable", "error");
  } finally {
    setSavingItemId(null);
  }
};

  const getColumnsWithToggle = (columns) => {
  
    return [
      ...columns,
      {
        Header: "Items",
        id: "expander",
        Cell: ({ row }) =>
          row.original.items && row.original.items.length > 0 ? (
            <button
            className="btn btn-sm btn-outline-success"
            onClick={(e) => {
              e.stopPropagation();
              setExpandedRows((prev) => ({
                [row.id]: !prev[row.id], // only this row remains
              }));
              
            }}
          >
            {expandedRows[row.id] ? "Close Items" : "Show Items"}
          </button>
          
          ) : (
            "-"
          ),
      },
    ];
  };

  const fetchledgermasterdetails = async () => {
    try {
      const response = await apiClient.get(
        SERVER_BASE + "/ledgerMasters",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const options = response.data
        .map((ledger) => ({
          value: ledger.printName,
          label: ledger.printName,
          ledgerId: ledger.id,
        }));

      setLedgerOptions(options);
    } catch (error) {
      console.error("Error fetching ledger master details:", error);
    }
  };

  useEffect(() => {
    fetchledgermasterdetails();
  }, []);

  /* ================= FETCH VOUCHER ================= */
  const fetchVoucher = async () => {
    if (!voucherType) {
      Swal.fire("Required", "Please select Voucher Type", "warning");
      return;
    }
    if (!selectedLedger) {
      Swal.fire("Required", "Please select Ledger", "warning");
      return;
    }
  
    try {
      const res = await apiClient.post(
        SERVER_BASE + "/getledgerViseInventoryData",
        {
          voucherType: voucherType.value,
          ledgerId: selectedLedger ? selectedLedger.ledgerId : null,
        }
      );

      setVoucherData(res.data.data || []);
    } catch (err) {
      console.error("Error fetching voucher:", err);
    }
  };
  



  /* ================= TABLE ================= */
  const DataTable = ({ columns, data }) => {
    const tableInstance = useTable(
      {
        columns,
        data,
        autoResetExpanded: false,
        getRowId: (row) => String(row.id),
        expanded: expandedRows,               // 👈 controlled
        onExpandedChange: setExpandedRows,    // 👈 controlled
      },
      useGlobalFilter,
      useSortBy,
      useExpanded
    );
    
    
    

    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      state,
      setGlobalFilter,
    } = tableInstance;

    return (
      <>
        <div className="d-flex justify-content-between align-items-center">
          <input
            className="form-control w-50 mb-3"
            placeholder="Search..."
            value={state.globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
          />

<strong>Showing {rows.length} records</strong>

        </div>

        <table
          className="table table-bordered table-striped"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((hg) => (
              <tr {...hg.getHeaderGroupProps()}>
                {hg.headers.map((col) => (
                  <th {...col.getHeaderProps(col.getSortByToggleProps())}>
                    {col.render("Header")}
                    {col.isSorted ? (col.isSortedDesc ? " 🔽" : " 🔼") : ""}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
  {rows.map((row) => {
    prepareRow(row);
    return (
      <React.Fragment key={row.id}>
        <tr {...row.getRowProps()}>
          {row.cells.map((cell) => (
            <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
          ))}
        </tr>

        {expandedRows[row.id] && row.original.items && (
          <tr>
            <td colSpan={row.cells.length} className="bg-light">
            <div
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
              <table className="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Item Name</th>
                    <th>Qty</th>
                    <th>Unit</th>
                    <th>Returnable</th>
                  </tr>
                </thead>
                <tbody>
                  {row.original.items.map((item, idx) => (
                    <tr key={idx}>
                      <td >{idx + 1}</td>
                      <td>{item.itemName || item.item || item.printName }</td>
                      <td>{item.quantity || item.receivedQty}</td>
                      <td>{item.uom}</td>
                      <td>
  {voucherType?.value == "Delivery Challan" ? (
    <div className="d-flex gap-2 align-items-center">
     <div
  onClick={(e) => e.stopPropagation()}
  onMouseDown={(e) => e.stopPropagation()}
>
  <Select
    options={booleanOptions}
    value={booleanOptions.find(
      (o) => o.value === (item.returnable ? "Yes" : "No")
    )}
    isDisabled={!editableItems[getItemKey(row.original.id, item.id)]}
    onChange={(opt) =>
      handleReturnableChange(
        row.original.id,
        item.id,
        opt.value
      )
    }
    styles={{
      container: (base) => ({ ...base, width: 90 }),
    }}
  />
</div>



{!editableItems[getItemKey(row.original.id, item.id)] ? (
  <button
    className="btn btn-sm btn-outline-primary"
    onClick={(e) => {
      e.stopPropagation();
      handleEditItem(
        row.original.id,
        item.id,
        item.returnable
      );
    }}
  >
    Edit
  </button>
) : (
  <>
    <button
      className="btn btn-sm btn-success"
      disabled={savingItemId == item.id}
      onClick={(e) => {
        e.stopPropagation();
        handleSaveItem(
          row.original.id,
          item.id,
          item.returnable
        );
      }}
    >
      {savingItemId == item.id ? "Saving..." : "Save"}
    </button>

    <button
      className="btn btn-sm btn-outline-secondary"
      onClick={(e) => {
        e.stopPropagation();
        handleCancelItem(row.original.id, item.id);
      }}
    >
      Cancel
    </button>
  </>
)}

    </div>
  ) : (
 null
  )}
</td>

                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </td>
          </tr>
        )}
      </React.Fragment>
    );
  })}
</tbody>

        </table>
      </>
    );
  };

  /* ================= ALL YOUR COLUMNS ================= */
  const voucherColumns = {
    // "Receipt Voucher": [
    //   { Header: "S.No", Cell: ({ row }) => row.index + 1 },
    //   {
    //     Header: "Date",
    //     accessor: "entryDate",
    //     Cell: ({ value }) =>
    //       value ? moment(value).format("DD-MMM-YY") : "",
    //   },
    //   {
    //     Header: "RV No",
    //     accessor: "rvNo",
    //     Cell: ({ row }) => {
    //       const d = row.original;
    //       return (
    //         <Link
    //           to={`/PreviewExternalReceiptVoucher?voucherId=${d.id}&type=external`}
    //           target="_blank"
    //           rel="noopener noreferrer"
    //           style={{ color: "#0d6efd", textDecoration: "none" }}
    //         >
    //           {d.rvNo}
    //         </Link>
    //       );
    //     }
    //   },
    //   { Header: "Ledger Name", accessor: "ledgerName" },
    //   { Header: "Status", accessor: "receiptStatus" },
    //   {
    //     Header: "Created",
    //     accessor: (row) =>
    //       `${row.createdBySewadar?.firstName || ""} ${
    //         row.createdBySewadar?.lastName || ""
    //       }`,
    //   },
    //   {
    //     Header: "Created At",
    //     accessor: (row) =>
    //       row.createdAt
    //         ? moment(row.createdAt).format("DD MMM YY hh:mm A")
    //         : "",
    //   },
    // ],

//     "Addition": [
//       { Header: "S.No", Cell: ({ row }) => row.index + 1 },
//       {
//         Header: "Date",
//         accessor: "date",
//         Cell: ({ value }) =>
//           value ? moment(value).format("DD-MMM-YY") : "",
//       },
// {
//   Header: "Ref No.",
//   accessor: "draftCode",
//   Cell: ({ row }) => {
//     const d = row.original;
//     return (
//       <Link
//   to={`/previewInventory?draftId=${d.id}&type=externalAddition`}
//   target="_blank"
//   rel="noopener noreferrer"
//   style={{ color: "#0d6efd", textDecoration: "none" }}
// >
//   {d.draftCode}
// </Link>

//     );
//   },
// },
//       { Header: "Department", accessor: "department" },
//       { Header: "Event", accessor: "purpose" },
//       { Header: "Status", accessor: "status" },
//       { Header: "Created", accessor: "createdBy" },
//       {
//         Header: "Created At",
//         accessor: (row) =>
//           row.created_at
//             ? moment(row.created_at).format("DD MMM YY hh:mm A")
//             : "",
//       },
//     ],

    "Delivery Challan": [
      { Header: "S.No", Cell: ({ row }) => row.index + 1 },
        {
          Header: "Date",
          accessor: "date",
          Cell: ({ value }) =>
            value ? moment(value).format("DD-MMM-YY") : "",
        },
        {
          Header: "Challan No",
          accessor: "refNo",
          Cell: ({ row }) => {
            const d = row.original;
            return (
              <Link
                to={`/previewDeliveryChallan?challanId=${d.id}&type=Externalchallan`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#0d6efd", textDecoration: "none" }}
              >
                {d.prefix}{d.refNo}
              </Link>
            );
          },
        },
      { Header: "Created", accessor: "createdBy" },
    ],

//     "Deduction": [
//       { Header: "S.No", Cell: ({ row }) => row.index + 1 },
//       {
//         Header: "Date",
//         accessor: "date",
//         Cell: ({ value }) =>
//           value ? moment(value).format("DD-MMM-YY") : "",
//       },
//       {
//         Header: "Ref No.",
//         accessor: "draftCode",
//         Cell: ({ row }) => {
//           const d = row.original;
//           return (
//             <Link
//         to={`/previewInventory?draftId=${d.id}&type=externalAddition`}
//         target="_blank"
//         rel="noopener noreferrer"
//         style={{ color: "#0d6efd", textDecoration: "none" }}
//       >
//         {d.draftCode}
//       </Link>
      
//           );
//         },
//       },
//       { Header: "Department", accessor: "department" },
//       { Header: "Event", accessor: "purpose" },
//       { Header: "Status", accessor: "status" },
//       { Header: "Created", accessor: "createdBy" },
//       {
//         Header: "Created At",
//         accessor: (row) =>
//           row.created_at
//             ? moment(row.created_at).format("DD MMM YY hh:mm A")
//             : "",
//       },
//     ],

//     "Opening Stock Ledger": [
//       { Header: "S.No", Cell: ({ row }) => row.index + 1 },
//       {
//         Header: "Date",
//         accessor: "createdAt",
//         Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
//       },
//       {
//         Header: "Ref No.",
//         accessor: "openingStockNo",
//         Cell: ({ row }) => {
//           const r = row.original;
//           return (
//             <Link
//               to={`/PreviewOpeningStockLedger?draftId=${r.id}&type=externalLedgerOp`}
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ color: "#0d6efd", textDecoration: "none" }}
//             >
//               {r.openingStockNo}
//             </Link>
//           );
//         },
//       },      
//       { Header: "Ledger", accessor: "ledgerName" },
//       { Header: "Status", accessor: "status" },
//       { Header: "Created", accessor: "createdBy" },
//       {
//         Header: "Created At",
//         accessor: (row) =>
//           row.createdAt
//             ? moment(row.createdAt).format("DD MMM YY hh:mm A")
//             : "",
//       },
//     ],

//     "Addition Ledger": [
//       { Header: "S.No", Cell: ({ row }) => row.index + 1 },
//       {
//         Header: "Date",
//         accessor: "date",
//         Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
//       },
//       {
//         Header: "Ref No.",
//         accessor: "draftCode",
//         Cell: ({ row }) => {
//           const d = row.original;
//           return (
//             <Link
//         to={`/PreviewInventoryLedger?draftId=${d.id}&type=externalAddition`}
//         target="_blank"
//         rel="noopener noreferrer"
//         style={{ color: "#0d6efd", textDecoration: "none" }}
//       >
//         {d.draftCode}
//       </Link>
      
//           );
//         },
//       },
//       { Header: "Event", accessor: "purpose" },
//       { Header: "Status", accessor: "status" },
//       { Header: "Created", accessor: "createdBy" },
//       {
//         Header: "Created At",
//         accessor: (row) =>
//           row.created_at
//             ? moment(row.created_at).format("DD MMM YY hh:mm A")
//             : "",
//       },
//     ],

//     "Deduction Ledger": [
//       { Header: "S.No", Cell: ({ row }) => row.index + 1 },
//       {
//         Header: "Date",
//         accessor: "date",
//         Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
//       },
//       {
//         Header: "Ref No.",
//         accessor: "draftCode",
//         Cell: ({ row }) => {
//           const d = row.original;
//           return (
//             <Link
//         to={`/PreviewInventoryLedger?draftId=${d.id}&type=externalAddition`}
//         target="_blank"
//         rel="noopener noreferrer"
//         style={{ color: "#0d6efd", textDecoration: "none" }}
//       >
//         {d.draftCode}
//       </Link>
      
//           );
//         },
//       },
//       { Header: "Event", accessor: "purpose" },
//       { Header: "Status", accessor: "status" },
//       { Header: "Created", accessor: "createdBy" },
//       {
//         Header: "Created At",
//         accessor: (row) =>
//           row.created_at
//             ? moment(row.created_at).format("DD MMM YY hh:mm A")
//             : "",
//       },
//     ],
  };

  const voucherOptions = Object.keys(voucherColumns).map((v) => ({
    label: v,
    value: v,
  }));

  return (
    <div className="formcontainer mt-5">
      <h5>Item Return Management</h5>

      <div className="card p-3 mb-3">
        <div className="row align-items-end">
        <div className="col-md-4">
            <label className="form-label">Ledger</label>
            <Select
              options={ledgerOptions}
              value={selectedLedger}
              onChange={setSelectedLedger}
              isClearable
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Voucher Type</label>
            <Select
              options={voucherOptions}
              value={voucherType}
              onChange={(v) => {
                setVoucherType(v);
                setVoucherData([]);
              }}
            />
          </div>

  

          <div className="col-md-2">
            <button
              className="btn btn-primary w-100"
              disabled={!voucherType}
              onClick={fetchVoucher}
            >
              Get Data
            </button>
          </div>
        </div>
      </div>

      {voucherType && voucherData.length > 0 && (
       <DataTable
       columns={getColumnsWithToggle(voucherColumns[voucherType.value])}
       data={voucherData}
     />
     
      )}
    </div>
  );
};

export default ItemReturnManagement;
